export class EnumUtils {
    public static getKeyByValue(EnumType: Object, value: any): string {
        return Object.keys(EnumType).find(key => EnumType[key] === value);
    }


    /**
     * returns key for value and value for key
     * @param EnumType
     * @param value
     */
    public static translateWithEnum(EnumType: Object, value: any): string {
        let key = EnumType[value];
        if (!key) {
            key = Object.keys(EnumType).find(key => EnumType[key] === value);
            if (!key) {
                console.warn('unexpected enum key "' + value + '" in enum:', EnumType);
                return null;
            }
            return key;
        }
        return key.toString();
    }

    // public static enumToKeyValues(EnumType: Object): { key: string, value: string }[] {
    //     return Object.keys(EnumType).map(key => {
    //         return {key: key, value: EnumType[key]};
    //     });
    // }
    //
    // public static enumToKeysValues(EnumType: Object): { keys: string[], values: string[] } {
    //     return {
    //         keys: Object.keys(EnumType),
    //         values: Object.keys(EnumType).map(key => EnumType[key])
    //     };
    // }

    public static checkKey(EnumType: Object, key: string) {
        const result = EnumType[key];
        if (result === undefined) {
            console.warn('unexpected enum key "' + key + '" in enum:', EnumType);
        }
        return key;
    }
}


/**
 * Maps a string to its corresponding value in the given enum.
 * @param enumType - The enum to map the string to.
 * @param key - The string key to look up in the enum.
 * @returns The corresponding value from the enum, or an empty string if not found.
 */
export function getEnumValue(enumType: Record<string, string>, key: string): string {
    return enumType[key] || '';
}


